import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import MobilePublicSearchBar from 'components/MobilePublicSearchBar'
import PublicSearchBar from './PublicSearchBar'

const PublicSearchBarParent = ({ initialDestination, sizeToChange = 'lg' }) => {
  const [selectedDestination, setSelectedDestination] = useState(initialDestination)

  useEffect(() => {
    if (initialDestination) {
      setSelectedDestination(initialDestination)
    }
  }, [initialDestination])

  return (
    <>
      <div className={`hidden ${sizeToChange}:block`}>
        <PublicSearchBar fixed selectedDestination={selectedDestination} setSelectedDestination={setSelectedDestination} />
      </div>
      <div className={`${sizeToChange}:hidden sticky top-0 z-30`}>
        <MobilePublicSearchBar fixed selectedDestination={selectedDestination} setSelectedDestination={setSelectedDestination} />
      </div>
    </>
  )
}

PublicSearchBarParent.propTypes = {
  initialDestination: PropTypes.object,
  sizeToChange: PropTypes.string,
}

export default PublicSearchBarParent
